{
  "LOGIN": {
    "TITLE": "Logga in på kontaktcentret",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Ange en giltig e-postadress"
    },
    "PASSWORD": {
      "LABEL": "Lösenord",
      "PLACEHOLDER": "Lösenord"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again.",
      "ACCOUNT_DEACTIVATED": "Ditt konto har inaktiverats. Kontakta din administratör.",
      "PASSWORD_LOGIN_DISABLED": "Inloggning med lösenord är inaktiverad för ditt konto. Logga in med OAuth istället (t.ex. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Glömt ditt lösenord?",
    "CREATE_NEW_ACCOUNT": "Skapa nytt konto",
    "SUBMIT": "Logga in"
  }
}
